import * as React from 'react';
import * as Glob from '../Globale';
import { BaseComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { CampoNumero } from './CampoNumero';

interface IInputLimiteProps extends Dati.IBaseProps {
    Minimo?: number;
    Massimo?: number;
    Buono?: number;
    BuonoFrase?: string;
    Accettabile?: number;
    AccettabileFrase?: string;
    Scarso?: number;
    ScarsoFrase?: string;
    NDFrase?: string;
    Valore: number;
    Indicatore?: string;
    Label?: string;
    SuccessCSS?: string;
    DangerCSS?: string;
    WarningCSS?: string;
    Incremento?: number;
    AbilitaIncremento?: boolean;
    AbilitaDecremento?: boolean;
    AbilitamentoBackGroundColor?: boolean;
    Verso?: string;
    Precisione?: number;
    Disabilitato?: boolean;
    ValoreNeutro?: number;
}

export class InputLimite extends BaseComponent<IInputLimiteProps, {}> {
    private _Label: string;
    private _SuccessCSS: string;
    private _DangerCSS: string;
    private _WarningCSS: string;
    private _SuccessBackgroundCSS: string;
    private _DangerBackgroundCSS: string;
    private _WarningBackgroundCSS: string;
    private _NDBackgroundCSS: string;
    private _StatoCSS: string = "";
    private _StatoMessaggio: string = "";
    //private _BaseStatoCSS: string = "form-group kt-form login-form__group row"
    private _Incremento: number;
    private _Indicatore = <span></span>;
    private _Minimo: number;
    private _Massimo: number;
    private _BackgroundBaseCSS: string = "form-control TextRight";
    private _BackgroundCSS: string = this._BackgroundBaseCSS;

    private _Verso: string = ">";

    private I = document.createElement('input');

    private _MinAssoluto: number = -9999999999999;
    private _MaxAssoluto: number = 9999999999999;

    public constructor(props: any) {
        super(props);

        this.I.value = this.props.Valore.toString();

        Glob.Log(Glob.LogCat.InputCalcolatore, false, this.props.Id, this.props.Valore);

        this.props.Minimo == undefined ? this._Minimo = this._MinAssoluto : this._Minimo = this.props.Minimo;
        this.props.Massimo == undefined ? this._Massimo = this._MaxAssoluto : this._Massimo = this.props.Massimo;
        this.props.Scrittura == undefined ? this._Scrittura = true : this._Scrittura = this.props.Scrittura;
        this.props.Visibile == undefined ? this._Visibile = true : this._Visibile = this.props.Visibile;
        this.props.CSS == undefined ? this._BaseCSS = "" : this._BaseCSS = this.props.CSS;
        this.props.Label == undefined ? this._Label = "" : this._Label = this.props.Label;
        this.props.SuccessCSS == undefined ? this._SuccessCSS = "has-success" : this._SuccessCSS = this.props.SuccessCSS;
        this.props.DangerCSS == undefined ? this._DangerCSS = "has-danger" : this._DangerCSS = this.props.DangerCSS;
        this.props.WarningCSS == undefined ? this._WarningCSS = "has-warning" : this._WarningCSS = this.props.WarningCSS;

        if (this.props.AbilitamentoBackGroundColor != undefined && this.props.AbilitamentoBackGroundColor) {
            this._SuccessBackgroundCSS = "bg-success";
            this._WarningBackgroundCSS = "bg-warning";
            this._DangerBackgroundCSS = "bg-danger";
            this._NDBackgroundCSS = "bg-info";
        } else {
            this._SuccessBackgroundCSS = "";
            this._WarningBackgroundCSS = "";
            this._DangerBackgroundCSS = "";
            this._NDBackgroundCSS = "";
        }

        this.props.Incremento == undefined ? this._Incremento = 1 : this._Incremento = this.props.Incremento;

        //this.props.Data == undefined ? this._Data = new Date(Date.now) : this._Data = this.props.Data;

        this.props.Indicatore == undefined ? this._Indicatore = <span></span> : this._Indicatore = <span className="input-group-addon bootstrap-touchspin-prefix">{this.props.Indicatore}</span>;

        this.props.Verso == undefined ? this._Verso = ">" : this._Verso = this.props.Verso;

        this.ControlloLimite(this.props.Valore);
    }

    private ControlloLimite(newValore: number) {
        this._StatoCSS = '';
        let stato: string = this.StatoLimite(newValore);

        this._StatoCSS = this.StatoCSS(stato);
        this._StatoMessaggio = this.StatoMessaggio(stato);
        this._BackgroundCSS = this.StatoSfondo(stato);
    }

    private StatoSfondo(stato: string): string {
        if (stato == "Buono") {
            return this._BackgroundBaseCSS + " " + this._SuccessBackgroundCSS;
        }
        else if (stato == "Accettabile") {
            return this._BackgroundBaseCSS + " " + this._WarningBackgroundCSS;
        }
        else if (stato == "Scarso") {
            return this._BackgroundBaseCSS + " " + this._DangerBackgroundCSS;
        }
        else if (stato == "ND") {
            return this._BackgroundBaseCSS + " " + this._NDBackgroundCSS;
        }
        else {
            return this._BackgroundBaseCSS;
        }
    }

    private StatoMessaggio(stato: string): string {
        if (stato == "Buono") {
            return this.props.BuonoFrase == undefined ? "" : this.props.BuonoFrase;
        }
        else if (stato == "Accettabile") {
            return this.props.AccettabileFrase == undefined ? "" : this.props.AccettabileFrase;
        }
        else if (stato == "Scarso") {
            return this.props.ScarsoFrase == undefined ? "" : this.props.ScarsoFrase;
        }
        else if (stato == "ND") {
            return this.props.NDFrase == undefined ? "" : this.props.NDFrase;
        }
        else {
            return "";
        }
    }

    private StatoCSS(stato: string): string {
        if (stato == "Buono") {
            return this._SuccessCSS;
        }
        else if (stato == "Accettabile") {
            return this._WarningCSS;
        }
        else if (stato == "Scarso") {
            return this._DangerCSS;
        }
        else {
            return "";
        }
    }

    private StatoLimite(nuovoValore: number): string {
        if (this.props.BuonoFrase != undefined
            && this.props.AccettabileFrase != undefined
            && this.props.ScarsoFrase != undefined
            && this.props.Buono != undefined
            && this.props.Accettabile != undefined
            && this.props.Scarso != undefined) {

            var stato: string = "Buono";

            if (this._Verso == ">") {
                if ((nuovoValore * 1) >= (this.props.Buono * 1)) {
                    stato = "Buono";
                }
                else if ((nuovoValore * 1) < (this.props.Buono * 1) && (nuovoValore * 1) >= (this.props.Accettabile * 1)) {
                    stato = "Accettabile";
                }
                else {
                    stato = "Scarso";
                }
            } else {
                if ((nuovoValore * 1) <= (this.props.Buono * 1)) {
                    stato = "Buono";
                }
                else if ((nuovoValore * 1) > (this.props.Buono * 1) && (nuovoValore * 1) <= (this.props.Accettabile * 1)) {
                    stato = "Accettabile";
                }
                else {
                    stato = "Scarso";
                }
            }

            if (this.props.ValoreNeutro != undefined && this.props.ValoreNeutro == nuovoValore) {
                stato = "ND";
            }
            return stato;
        } else {
            return "";
        }
    }

    private OnClick(e: React.FormEvent<any>, op: string) {
        var NuovoValore: number = (this.props.Valore) * 1; //Forzo che sia number altrimenti crea problemi con valori stringa simili numero e va in accodamento
        op == "+" ? NuovoValore = NuovoValore + this._Incremento : NuovoValore = NuovoValore - this._Incremento;

        if (NuovoValore > this._Massimo)
            NuovoValore = this._Massimo;

        if (NuovoValore < this._Minimo)
            NuovoValore = this._Minimo;

        this.ControlloLimite(NuovoValore);

        this.I.value = NuovoValore.toString();
        this.I.name = this.props.Name;
        e.currentTarget = this.I;
        this.props.OnChange(e);
    }

    public SetValore(valore: number) {
        this.ControlloLimite(valore);
    }

    public render() {
        this.ControlloLimite(this.props.Valore);

        var hidden = "";
        if (!this._Visibile)
            hidden = "hidden";
        else
            hidden = "";

        var hiddenIncremento = "";
        var hiddenDecremento = "";

        if (this.props.AbilitaIncremento != undefined && !this.props.AbilitaIncremento)
            hiddenIncremento = "hidden";
        else
            hiddenIncremento = "input-group-btn";

        if (this.props.AbilitaDecremento != undefined && !this.props.AbilitaDecremento)
            hiddenDecremento = "hidden";
        else
            hiddenDecremento = "input-group-btn";

        return <div className={this.props.CSS != undefined ? this.props.CSS : "" + " " + this._BaseCSS + " " + this._StatoCSS + " " + hidden}>
            <label>{this._Label}</label>
            <div className="input-group bootstrap-touchspin">
                <span className={hiddenDecremento}>
                    <button disabled={!this._Scrittura} className="btn btn-secondary bootstrap-touchspin-down" name={this.props.Name} type="button" onClick={(e) => { this.OnClick(e, "-"); }}>-</button>
                </span>
                <CampoNumero
                    Scrittura={this._Scrittura}
                    Id={this.props.Id}
                    Valore={this.props.Valore}
                    Name={this.props.Name}
                    OnChange={(e) => { this.setState({ Valore: (e as React.FormEvent<any>).currentTarget.value }); this.ControlloLimite(Number((e as React.FormEvent<any>).currentTarget.value)); this.props.OnChange(e) }}
                    CSS={this._BackgroundCSS}
                    Minimo={this.props.Minimo}
                    Massimo={this.props.Massimo}
                    Precisione={this.props.Precisione}
                    Disabilitato={this.props.Disabilitato} />
                {this._Indicatore}
                <span className={hiddenIncremento}>
                    <button disabled={!this._Scrittura} className="btn btn-secondary bootstrap-touchspin-up" name={this.props.Name} type="button" onClick={(e) => { this.OnClick(e, "+"); }}>+</button>
                </span>
            </div>
            <div className="form-control-feedback">{this._StatoMessaggio}</div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/InputLimite.tsx